// NOTE: this is JS custom code for AMP

import Rails from '@rails/ujs';
import Sortable from 'sortablejs';

// Order: copy address between sections (radio buttons)
function initCopyAddress() {
  let copyRadios = document.querySelectorAll('input[type="radio"][data-target]');
  if(copyRadios.length > 0){
    const addressFields = ['nif', 'full_name', 'address', 'city', 'postal_code', 'province', 'country', 'address_details', 'email', 'phone'];
    copyRadios.forEach((radio) => {
      if(radio.dataset.copyBound) return;
      radio.dataset.copyBound = 'true';
      radio.addEventListener('change', function() {
        let target = this.dataset.target;
        if(this.value === 'new'){
          addressFields.forEach((field) => {
            let targetInput = document.getElementById('order_' + target + '_' + field);
            if(targetInput) targetInput.value = '';
          });
        } else {
          let source = this.dataset.source;
          addressFields.forEach((field) => {
            let sourceInput = document.getElementById('order_' + source + '_' + field);
            let targetInput = document.getElementById('order_' + target + '_' + field);
            if(sourceInput && targetInput) targetInput.value = sourceInput.value;
          });
        }
      });
    });
  }
}
document.addEventListener('DOMContentLoaded', initCopyAddress);
document.addEventListener('turbolinks:load', initCopyAddress);

// User form: the validator checkbox only applies to distributors
function initValidatorField() {
  let roleSelect = document.getElementById('user_role');
  let validatorField = document.getElementById('validator-field');
  if(!roleSelect || !validatorField) return;
  let checkbox = validatorField.querySelector('input[type="checkbox"]');
  function toggleValidatorField() {
    let isDistributor = roleSelect.value === 'distributor';
    validatorField.style.display = isDistributor ? '' : 'none';
    if(!isDistributor && checkbox) checkbox.checked = false;
  }
  toggleValidatorField();
  if(roleSelect.dataset.validatorBound) return;
  roleSelect.dataset.validatorBound = 'true';
  roleSelect.addEventListener('change', toggleValidatorField);
}
document.addEventListener('DOMContentLoaded', initValidatorField);
document.addEventListener('turbolinks:load', initValidatorField);

document.addEventListener('turbolinks:load', () => {
  // Admin validation acknowledgement checkbox
  let ackCheckbox = document.getElementById('admin-validation-ack');
  let submitActions = document.getElementById('user-submit-actions');
  if(ackCheckbox && submitActions){
    let submitBtn = submitActions.querySelector('input[type="submit"]');
    if(submitBtn) submitBtn.disabled = true;
    ackCheckbox.addEventListener('change', function(){
      submitActions.style.display = this.checked ? '' : 'none';
      if(submitBtn) submitBtn.disabled = !this.checked;
    });
  }

  // Close flash messages
  let close_icon = document.getElementById('close');
  if(close_icon != undefined){
    let flashRow = close_icon.parentElement;
    flashRow.style.transition = 'opacity 0.5s ease';
    function closeParent() {
      flashRow.style.display = 'none'
    }
    function fadeOutParent() {
      flashRow.style.opacity = '0';
      setTimeout(closeParent, 500);
    }
    close_icon.onclick = fadeOutParent;
    setTimeout(fadeOutParent, 3000);
  }

  // Sync user_id with practitioner selection
  let practitionerSelect = document.getElementById('practitioner-select');
  let userIdHidden = document.getElementById('user-id-hidden');
  if(practitionerSelect && userIdHidden){
    practitionerSelect.addEventListener('change', function(){
      let selected = practitionerSelect.options[practitionerSelect.selectedIndex];
      userIdHidden.value = selected.dataset.userId || '';
    });
  }

  // Menu control
  let open_menu = document.getElementById('open-menu');
  if(open_menu != null){
    let close_menu = document.getElementById('close-menu');
    function openMenu() {
      document.getElementById('menu').style.width = '250px';
    }
    function closeMenu() {
      document.getElementById('menu').style.width = '0';
    }
    open_menu.onclick = openMenu;
    close_menu.onclick = closeMenu;
  }

  // Language selector
  let languageSelector = document.getElementById('language-selector');
  if(languageSelector != null){
    languageSelector.addEventListener('change', function() {
      let url = new URL(window.location.href);
      url.searchParams.set('locale', this.value);
      window.location.href = url.toString();
    });
  }

  // New Service forever/permanent
  let forever_control = document.getElementById('forever-control');
  if(forever_control != null){
    let date_controls = document.getElementsByClassName('date');
    function foreverControl() {
      for(var i = 0; i < date_controls.length; i++){
        date_controls[i].disabled = forever_control.checked;
      }
    }
    forever_control.onclick = foreverControl;
  }

  // NO COMMISSION AIM unit
  let no_commission = document.getElementById('no_commission');
  if(no_commission != null){
    function noCommission() {
      let no_commission_value = document.getElementById('no_commission_value').value;
      document.getElementById('commission_date_control').value = null;
      document.getElementById('commission_date_control').disabled = true;
      document.getElementById('commission_info_control').value = no_commission_value;
    }
    no_commission.onclick = noCommission;
  }

  // Services counter (sendBeacon ensures delivery even when opening a new tab)
  let services_counters = document.querySelectorAll('.service_counter');
  services_counters.forEach((e) => {
    if(e.dataset.counterBound) return;
    e.dataset.counterBound = 'true';
    e.addEventListener('click', (event) => {
      const token = document.getElementsByName('csrf-token')[0].content;
      const serviceId = event.currentTarget.getAttribute('data-service-id');
      const aimId = event.currentTarget.getAttribute('data-aim-id');
      const url = '/count_services/' + serviceId + '/aims/' + aimId;
      navigator.sendBeacon(url, new Blob(
        [JSON.stringify({ authenticity_token: token })],
        { type: 'application/json' }
      ));
    });
  });

  // Tracking link modal for assembled → delivered transition
  let modal = document.getElementById('tracking-link-modal');
  if(modal){
    let triggers = document.querySelectorAll('.tracking-link-trigger');
    let aimIdInput = document.getElementById('tracking-link-aim-id');
    let linkInput = document.getElementById('tracking-link-input');
    let skipCheckbox = document.getElementById('tracking-link-skip');
    let errorSpan = document.getElementById('tracking-link-error');
    let confirmBtn = document.getElementById('tracking-link-confirm');
    let cancelBtn = document.getElementById('tracking-link-cancel');

    triggers.forEach((trigger) => {
      trigger.addEventListener('click', function(e){
        e.preventDefault();
        aimIdInput.value = this.dataset.aimId;
        linkInput.value = '';
        skipCheckbox.checked = false;
        errorSpan.style.display = 'none';
        modal.style.display = 'flex';
      });
    });

    cancelBtn.addEventListener('click', function(){
      modal.style.display = 'none';
    });

    modal.addEventListener('click', function(e){
      if(e.target === modal) modal.style.display = 'none';
    });

    confirmBtn.addEventListener('click', function(){
      let trackingLink = linkInput.value.trim();
      let skip = skipCheckbox.checked;
      if(!trackingLink && !skip){
        errorSpan.style.display = 'block';
        return;
      }
      errorSpan.style.display = 'none';
      modal.style.display = 'none';
      let aimId = aimIdInput.value;
      let csrfToken = document.getElementsByName('csrf-token')[0].content;
      // Uses Rails UJS pattern: server returns JS to execute (same as remote: true links)
      Rails.ajax({
        url: '/aims/' + aimId + '/update-state',
        type: 'POST',
        data: 'tracking_link=' + encodeURIComponent(trackingLink),
        dataType: 'script'
      });
    });
  }

  // Void order modal (pending_validation, pending_acceptance, admin show)
  let voidModal = document.getElementById('void-payment-modal');
  if(voidModal){
    let voidForm = document.getElementById('void-payment-form');
    let voidReason = document.getElementById('void-payment-reason');
    let voidError = document.getElementById('void-payment-error');
    let voidCancel = document.getElementById('void-payment-cancel');
    let voidBackFilter = document.getElementById('void-payment-back-filter');
    let voidTriggers = document.querySelectorAll('.void-payment-trigger');

    voidTriggers.forEach((trigger) => {
      trigger.addEventListener('click', function(e){
        e.preventDefault();
        let orderId = this.dataset.orderId;
        voidForm.action = '/orders/' + orderId + '/void_payment';
        if(voidBackFilter){
          voidBackFilter.value = this.dataset.backFilter || '';
        }
        voidReason.value = '';
        voidError.style.display = 'none';
        voidModal.style.display = 'flex';
        voidReason.focus();
      });
    });

    voidCancel.addEventListener('click', function(e){
      e.preventDefault();
      voidModal.style.display = 'none';
    });

    voidModal.addEventListener('click', function(e){
      if(e.target === voidModal) voidModal.style.display = 'none';
    });

    voidForm.addEventListener('submit', function(e){
      if(voidReason.value.trim() === ''){
        e.preventDefault();
        voidError.style.display = 'block';
      }
    });
  }

  // Reject manual order modal
  let rejectManualModal = document.getElementById('reject-manual-modal');
  if(rejectManualModal){
    let rejectForm = document.getElementById('reject-manual-form');
    let rejectReason = document.getElementById('reject-manual-reason');
    let rejectError = document.getElementById('reject-manual-error');
    let rejectTrigger = document.getElementById('reject-manual-trigger');
    let rejectCancel = document.getElementById('reject-manual-cancel');

    if(rejectTrigger){
      rejectTrigger.addEventListener('click', function(e){
        e.preventDefault();
        rejectReason.value = '';
        rejectError.style.display = 'none';
        rejectManualModal.style.display = 'flex';
        rejectReason.focus();
      });
    }

    if(rejectCancel){
      rejectCancel.addEventListener('click', function(e){
        e.preventDefault();
        rejectManualModal.style.display = 'none';
      });
    }

    rejectManualModal.addEventListener('click', function(e){
      if(e.target === rejectManualModal) rejectManualModal.style.display = 'none';
    });

    rejectForm.addEventListener('submit', function(e){
      if(rejectReason.value.trim() === ''){
        e.preventDefault();
        rejectError.style.display = 'block';
      }
    });
  }
});

